module.exports = __webpack_public_path__ + "static/media/6px_invert.d58708ee.png";